export default "__VITE_ASSET__BR0Oc2X$__"